import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import  PRETTY from '../../assets/img/logo/PRETTYLASHED.png';

import CartCounter from '../Cart/CartCounter';

import New from '../../assets/custom-banner.png';
import BeautyTools from '../../assets/canva-woman.jpg';
import threeDMink from '../../assets/make-up_brush.f150bc09.jpg';
import SibMink from '../../assets/make-up_compact.5d1805f0.jpg';
import lipPaint from '../../assets/img/headers/sib-header.jpg';

const StylesHeader = ({ style, header }) => {
  let Header = null;

  switch (header) {
    case '.New Products':
      Header = New ;
      break;
    case '.Beauty Tools':
      Header = BeautyTools;
      break;
    case '.3D Mink':
      Header = threeDMink;
      break;
    case '.Siberian Mink':
      Header = SibMink;
      break;
    case '.Lip Paint':
      Header = lipPaint;
      break;
    default:
      Header = BeautyTools;
  }

  

  return (
    <header
      className="medium-header light push"
      style={{
        backgroundImage: `url(${Header})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundOrigin: 'border-box',
        backgroundAttachment: 'scroll'
      }}>
      <div className="nav-container">
        <nav className="primary-nav">
          <Link to="/products">Products</Link>
          <Link to="/styles">Styles</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/about">About</Link>
        </nav>
        <div className="logo">
          <Link to="/" className="logo-link">
            <span className="hide-content">Pretty & Lashed by Shanise</span>
            <div className="big-logo" aria-hidden="true">
            <img alt="Shanise the founder" src={PRETTY} />
            </div>
          </Link>
        </div>
        <nav className="secondary-nav light">
          <CartCounter />
        </nav>
      </div>
      <div className="header-container light">
        <div className="content">
          <h1>
            {style}
            <span className="hide-content"> styles</span>
          </h1>
        </div>
      </div>
    </header>
  );
};

const mapStateToProps = ({ styles: { style, header } }) => ({
  style,
  header
});

export default connect(mapStateToProps)(StylesHeader);



// WEBPACK FOOTER //
// ./src/components/Styles/StylesHeader.js